import ExtendableError from 'es6-error'

export abstract class BaseException extends ExtendableError {
  code: TypeExceptionCode
  reason?: string

  constructor(
    name: string,
    code: TypeExceptionCode,
    message?: string,
    reason?: string,
  ) {
    super(message)
    this.name = name
    this.code = code
    this.reason = reason
  }
}
